import { Link } from "wouter";
import { BookOpen, ArrowLeft } from "lucide-react";
import { Footer } from "@/components/layout/footer";
import { useTheme } from "@/lib/theme-context";
import { Sun, Moon } from "lucide-react";

export function LegalLayout({ title, lastUpdated, children }: {
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
}) {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <nav className="sticky top-0 z-50 border-b border-border bg-card/80 backdrop-blur-md">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link href="/">
            <div className="flex items-center gap-2.5 cursor-pointer hover:opacity-80 transition-opacity">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-primary to-accent flex items-center justify-center">
                <BookOpen className="w-4 h-4 text-white" />
              </div>
              <span className="font-display font-bold text-lg text-foreground">Lerni</span>
            </div>
          </Link>
          <button
            onClick={toggleTheme}
            aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
            className="p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
          >
            {theme === "dark" ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
          </button>
        </div>
      </nav>

      <main className="flex-1 max-w-3xl mx-auto w-full px-6 py-14">
        <Link href="/">
          <div className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors mb-10 cursor-pointer">
            <ArrowLeft className="w-4 h-4" />
            Back to home
          </div>
        </Link>

        <p className="text-xs text-muted-foreground mb-3">Last updated: {lastUpdated}</p>
        <h1 className="text-4xl font-display font-bold mb-10 text-foreground">{title}</h1>

        <div className="prose prose-sm sm:prose-base max-w-none dark:prose-invert prose-headings:font-display prose-headings:font-bold prose-h2:text-xl prose-h2:mt-10 prose-h2:mb-3 prose-p:text-muted-foreground prose-li:text-muted-foreground prose-strong:text-foreground">
          {children}
        </div>
      </main>

      <Footer />
    </div>
  );
}
